import { CloseIcon, Dialog, Flex } from "@fluentui/react-northstar";
import React from "react";
import { WrapperIcon } from "../../../../common/styles";
import { ClipboardTask20Regular } from "@fluentui/react-icons";
import { CompoundButtonStyle } from "../../../addEmployees/styles/stepTasks";
import { ALink } from "../../../addEmployees/styles";
import StepTitle from "../../../../components/StepsTitle/StepTitle";
import FooterActionButtons from "../../components/footer/FooterActionButtons";
import { ContentImportTemplates } from "../../components/dialogsContents/ContentImportTemplates";
import { _api_get_model } from "../../api";
import useLogicTasksTemplates from "../../hooks/useLogicTasksTemplates";
import useLogicTaskIndividual from "../../hooks/useLogicTaskIndividual";
import AddIndividualTask from "../../../../components/Dialogs/AddIndividualTask/AddIndividualTask";
import { FormProvider } from "react-hook-form";
import { TableStyle, TextPrimary } from "./index.style";
import { HEADER } from "../../constants";
import { _format_tasks_definition_table } from "../../utils/func.tasks";

const StepTasks = () => {
    const { t, dialog, query } = useLogicTasksTemplates();
    const {
        dialog: dialog_individual_task,
        form,
        list_tasks_formated,
        navigation,
        footer,
    } = useLogicTaskIndividual();

    return (
        <Flex fill column space="between" gap="gap.large">
            {/* {confirmation.showModal && (
                <div className="modal">
                    <div className="modal-content">
                        <h2>Êtes-vous sûr de vouloir quitter ?</h2>
                        <button onClick={confirmation.handleConfirmLeave}>
                            Oui
                        </button>
                        <button onClick={confirmation.handleCancelLeave}>
                            Non
                        </button>
                    </div>
                </div>
            )} */}
            <Flex column gap="gap.large">
                <StepTitle
                    title="Attribution de tâches"
                    step_number={5}
                    is_required={false}
                />
            </Flex>
            <Flex styles={{ marginTop: "24px" }} gap="gap.large">
                <Flex.Item>
                    <Dialog
                        open={dialog.open}
                        cancelButton={{
                            content: t("common.cancel"),
                            flat: true,
                        }}
                        confirmButton={{
                            content: t(
                                "pages.add_employee.step_tasks.dialog.btn_add_task"
                            ),
                            disabled:
                                query?.formatedTemplatesJson?.length === 0,
                            flat: true,
                        }}
                        content={
                            <ContentImportTemplates
                                formatedTemplatesJson={
                                    query.formatedTemplatesJson
                                }
                                isLoading={query.isLoading}
                            />
                        }
                        header={t("pages.add_employee.step_tasks.dialog.title")}
                        headerAction={{
                            icon: <CloseIcon />,
                            title: t("common.close"),
                            onClick: dialog.onCloseModal,
                        }}
                        onCancel={dialog.onCloseModal}
                        onConfirm={dialog.onConfirmModal}
                        trigger={
                            <CompoundButtonStyle
                                icon={
                                    <WrapperIcon
                                        vAlign="center"
                                        hAlign="center"
                                    >
                                        <ClipboardTask20Regular
                                            style={{
                                                color: "var(--color-primary)",
                                            }}
                                        />
                                    </WrapperIcon>
                                }
                                secondaryContent={t(
                                    "pages.add_employee.step_tasks.buttons.templates.descr"
                                )}
                                onClick={dialog.onOpenModal}
                            >
                                {t(
                                    "pages.add_employee.step_tasks.buttons.templates.header"
                                )}
                            </CompoundButtonStyle>
                        }
                    />
                </Flex.Item>
                {/* ADD TASK. */}
                <Flex vAlign="center">
                    <FormProvider {...form.methods}>
                        <form
                            onSubmit={form.methods.handleSubmit(
                                form.methods.onSubmit
                            )}
                        >
                            <Dialog
                                header={"Ajouter une tâche"}
                                headerAction={
                                    <CloseIcon
                                        onClick={
                                            dialog_individual_task.onCloseModal
                                        }
                                    />
                                }
                                onCancel={dialog_individual_task.onCloseModal}
                                cancelButton="Annuler"
                                confirmButton={{
                                    content: "Ajouter la tâche",
                                }}
                                onConfirm={() => {
                                    return form.methods.handleSubmit(
                                        form.methods.onSubmit
                                    )();
                                }}
                                content={
                                    <AddIndividualTask
                                        generatedId={new Date().getTime()}
                                    />
                                }
                                open={dialog_individual_task.open}
                                trigger={
                                    <ALink
                                        href="#"
                                        onClick={
                                            dialog_individual_task.onOpenModal
                                        }
                                    >
                                        {t(
                                            "pages.add_employee.step_tasks.buttons.new_task.header"
                                        )}
                                    </ALink>
                                }
                                styles={{
                                    maxHeight: "90%",
                                    width: "700px",
                                }}
                            />
                        </form>
                    </FormProvider>
                </Flex>
            </Flex>
            {/* LIST OF TASKS */}
            {list_tasks_formated?.length > 0 && (
                <Flex
                    column
                    gap="gap.medium"
                    fill
                    styles={{ marginTop: "15px" }}
                >
                    <Flex>
                        <TextPrimary>
                            {t("pages.add_employee.step_tasks.lists.title")}
                        </TextPrimary>
                    </Flex>
                    <Flex fill>
                        <TableStyle
                            header={HEADER}
                            rows={list_tasks_formated.reverse()}
                            aria-label="table of tasks"
                            styles={{ width: "100%" }}
                        />
                    </Flex>
                </Flex>
            )}
            {/* footer */}
            <FooterActionButtons
                enableButtonBackStep={true}
                enableButtonNextStep={true}
                isLoadingNextStep={footer.validate_all_step.isLoading}
                onClickBackStep={navigation.buttonBackStep}
                onClickNextStep={navigation.buttonNextStep}
            />
        </Flex>
    );
};

export default StepTasks;
